import React, { useState } from "react";
import Vehicles from "./components/Vehicles";
import VehicleContext from "../context/VehicleContext";

const Index = () => {
  const [active, setActive] = useState(false);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState("");

  return (
    <VehicleContext.Provider
      value={{
        search,
        setSearch,
        limit,
        setLimit,
        active,
        setActive,
      
      }}
    >
  
      <div className="mt-4">
        <Vehicles />
      </div>
    </VehicleContext.Provider>
  );
};

export default Index;